<template>
  <div>
    <!-- 小程序订单管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>小程序订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox" >
      <div class="types_boxs">
          <div :class="typeindex=='1'?'type_active':''" @click="typeClick('1')">今天</div>
          <div :class="typeindex=='2'?'type_active':''" @click="typeClick('2')">昨天</div>
          <div :class="typeindex=='3'?'type_active':''" @click="typeClick('3')">近一周</div>
          <div :class="typeindex=='4'?'type_active':''" @click="typeClick('4')">近一月</div>
          <div :class="typeindex=='5'?'type_active':''" @click="typeClick('5')">本月</div>
      </div>
      <div class="conentTitle">
        <el-input placeholder="手机号" v-model="data.Mobile" clearable />
        <el-input placeholder="小程序订单号" v-model="data.xcx_number" clearable />
        <el-input placeholder="雪务通订单号" v-model="data.jfy_number" clearable />
        <el-input placeholder="消费码/二维码" v-model="data.OrderCode" clearable />
        <el-date-picker
          v-model="value1"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button  type="primary" @click="btns">查询</el-button>
        <el-button type="primary" @click="exportRoute">去导出</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column prop="date" label="下单时间" width="180"></el-table-column>
          <el-table-column prop="ordernumber" label="小程序订单号" width="180"></el-table-column>
          <el-table-column prop="jfy_no" label="雪务通订单号" width="180"></el-table-column>
          <el-table-column prop="ordercode" label="消费码" width="140"></el-table-column>
          <el-table-column prop="trade_no" label="微信交易单号" width="200"></el-table-column>
          <el-table-column label="订单信息" width="420">
            <template slot-scope="scope">
              <div class="orderContent">
                <span @click="seeInfoFn(scope.row)">{{scope.row.productname || '产品名称'}}</span>
                <span>用户姓名：{{scope.row.username}}</span>
                <span>联系电话：{{scope.row.mobile}}</span>
                <span>购买数量：{{scope.row.number}}</span>
                <span>单价：{{scope.row.price}}</span>
                <span>订单金额：{{scope.row.money}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <div class="btns_cao">
                <el-button type="text" @click="seeInfoFn(scope.row)">查看详情</el-button>
                <el-button 
                  type="text" 
                  style="color:red;" 
                  @click="refundFn(scope.row)"
                  v-if="getRefundableCount(scope.row) > 0"
                >退款</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination 
          background 
          layout="prev, pager, next" 
          :total="data.total" 
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange" 
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 查看详情开始 -->
    <el-dialog
      :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="seeinfovisible"
      width="800px"
      :before-close="dialogClose">
      <el-divider></el-divider>
      <div v-if="orderDetail" class="detail-content">
        <div class="detail-item">
          <span class="detail-label">小程序订单号：</span>
          <span>{{orderDetail.ordernumber || orderDetail.OrderNumber}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">雪务通订单号：</span>
          <span>{{orderDetail.jfy_no || orderDetail.jfy_number}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">消费码：</span>
          <span>{{orderDetail.ordercode || orderDetail.OrderCode}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">微信交易单号：</span>
          <span>{{orderDetail.trade_no}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">下单时间：</span>
          <span>{{orderDetail.date || orderDetail.CreateTime}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">用户姓名：</span>
          <span>{{orderDetail.username || orderDetail.consumer}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">手机号：</span>
          <span>{{orderDetail.mobile || orderDetail.Mobile}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">产品名称：</span>
          <span>{{orderDetail.productname}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">购买数量：</span>
          <span>{{orderDetail.number}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">单价：</span>
          <span>{{orderDetail.price}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">订单金额：</span>
          <span>{{orderDetail.money || orderDetail.ActFee}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">已使用数量：</span>
          <span>{{orderDetail.usecount || 0}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">已退款数量：</span>
          <span>{{orderDetail.canclecount || 0}}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">可退款数量：</span>
          <span>{{getRefundableCount(orderDetail)}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看详情结束 -->
    <!-- 退款对话框开始 -->
    <el-dialog
      :close-on-click-modal="false"
      title="退款"
      :visible.sync="refundVisible"
      width="500px"
      :before-close="refundDialogClose">
      <el-divider></el-divider>
      <div v-if="refundRow" class="refund-content">
        <div class="refund-item">
          <span class="refund-label">小程序订单号：</span>
          <span>{{refundRow.ordernumber}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">雪务通订单号：</span>
          <span>{{refundRow.jfy_no}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">购买数量：</span>
          <span>{{refundRow.number}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">已使用数量：</span>
          <span>{{refundRow.usecount || 0}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">已退款数量：</span>
          <span>{{refundRow.canclecount || 0}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">可退款数量：</span>
          <span>{{getRefundableCount(refundRow)}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">单价：</span>
          <span>{{refundRow.price}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">订单金额：</span>
          <span>{{refundRow.money}}</span>
        </div>
        <div class="refund-item">
          <span class="refund-label">退款数量：</span>
          <el-input-number 
            v-model="refundData.refundnum" 
            :min="1" 
            :max="getRefundableCount(refundRow)"
            placeholder="请输入退款数量"
            style="width: 100%"
            @change="calculateRefundMoney"
          ></el-input-number>
        </div>
        <div class="refund-item">
          <span class="refund-label">可退款金额：</span>
          <el-input 
            v-model="refundData.refundmoney" 
            placeholder="可退款金额"
            style="width: 100%"
            disabled
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogClose" :disabled="refundLoading">取 消</el-button>
        <el-button type="primary" @click="confirmRefund" :loading="refundLoading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 退款对话框结束 -->
  </div>
</template>

<script>
import {getXcxOrderList, xcxRefund} from '@/request/scenic.js'
import {MessageBox, Message} from 'element-ui'
export default {
  data() {
    return {
      loading:true,
      seeinfovisible: false, // 查看详情
      refundVisible: false, // 退款对话框
      refundLoading: false, // 退款loading
      tableData: [],
      value1: "",
      typeindex: '',
      orderDetail: null,
      refundRow: null, // 退款行数据
      refundData: {
        refundnum: 1, // 退款数量
        refundmoney: '' // 退款金额
      },
      data:{
        token:window.sessionStorage.getItem('Token'),
        Mobile:'',
        xcx_number:'',
        jfy_number:'',
        OrderCode:'',
        start_time:'',
        end_time:'',
        page:1,
        page_size:12,
        total:0
      }
    };
  },
  created(){
    this.getList()
  },
  methods: {
    typeClick(e){
      if(e==this.typeindex){
        return false
      }
      this.typeindex  = e
      if(e==1){
        this.newDataList()
      }else if(e==2){
        this.yestDay()
      }else if(e==3){
        this.getLastWeek()
      }else if(e==4){
        this.getAMonth()
      }else if(e==5){
        this.getCurrentMonthFirstDay()
      }
    },
    // 今天
    newDataList(){
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear()+"-" + (day2.getMonth()+1) + "-" + day2.getDate();
      this.value1 = [s2,s2]
      this.btns()
    },
    // 昨天
    yestDay(){
      var day1 = new Date();
      day1.setTime(day1.getTime()-24*60*60*1000);
      var s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate();
      this.value1 = [s1,s1]
      this.btns()
    },
    // 本月日期（1号到本月最后一天）
    getCurrentMonthFirstDay(){
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var date2 = new Date();
      date2.setMonth(date2.getMonth());
      var y2 = date2.getFullYear();
      var m2 = date2.getMonth() + 1;
      m2 = m2 < 10 ? '0' + m2 : m2;
      var defaultStartDate=[y2,m2,'01'].join('-')
      var d = new Date(y, m, 0).getDate();
      d = d < 10 ? '0' + d : d;
      var defaultEndDate= [y,m,d].join('-')
      this.value1 = [defaultStartDate,defaultEndDate]
      this.btns()
    },
    // 本月1号到今天
    getCurrentMonthToToday(){
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var defaultStartDate = [y,m,'01'].join('-')
      var defaultEndDate = [y,m,d].join('-')
      this.value1 = [defaultStartDate,defaultEndDate]
    },
    // 近一个月
    getAMonth(){
      let end = new Date()
      let year = end.getFullYear()
      let month = end.getMonth() + 1
      let day = end.getDate()
      let dateObj = {}
      dateObj.end =
        year +
        '-' +
        (month >= 1 && month <= 9 ? '0' : '') +
        month +
        '-' +
        (day >= 0 && day <= 9 ? '0' : '') +
        day
      let endMonthDay = new Date(year, month, 0).getDate()
      if (month - 1 <= 0) {
        dateObj.start =
          year - 1 + '-' + 12 + '-' + (day >= 0 && day <= 9 ? '0' : '') + day
      } else {
        let startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate()
        if (startMonthDay < day) {
          if (day < endMonthDay) {
            dateObj.start =
              year +
              '-' +
              (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
              (month - 1) +
              '-' +
              (startMonthDay - (endMonthDay - day) >= 1 &&
              startMonthDay - (endMonthDay - day) <= 9
                ? '0'
                : '') +
              (startMonthDay - (endMonthDay - day))
          } else {
            dateObj.start =
              year +
              '-' +
              (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
              (month - 1) +
              '-' +
              (startMonthDay >= 0 && startMonthDay <= 9 ? '0' : '') +
              startMonthDay
          }
        } else {
          dateObj.start =
            year +
            '-' +
            (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
            (month - 1) +
            '-' +
            (day >= 0 && day <= 9 ? '0' : '') +
            day
        }
      }
      this.value1 = [dateObj.start,dateObj.end]
      this.btns()
    },
    // 近一周
    getLastWeek(){
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var dateObj = {};
      dateObj.now = year + '-' + month + '-' + day;
      if(day - 7 <= 0){
          var lastMonthDay = new Date(year, (parseInt(month) - 1), 0).getDate();
          if(month - 1 <= 0){
              dateObj.last = (year - 1) + '-' + 12 + '-' + (31 - (7 - day));
          }else{
              dateObj.last = year + '-' + (month - 1) + '-' + (lastMonthDay - (7 - day));
          }
      }else{
          dateObj.last = year + '-' + month + '-' + (day -7);
      }
      this.value1 = [dateObj.last,dateObj.now]
      this.btns()
    },
    async exportRoute(){
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.$router.push({
        name:'report',
        params:{
            id:0,
            data:this.data,
            index:1524
        }
      })
    },
    currenchange(e){
      this.data.page = e
      this.loading =  true
      this.getList()
    },
    // 查询
    btns(){
      this.data.total = 0
      this.data.page  = 1
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.data.page = 1
      this.getList()
    },
    getList(){
      getXcxOrderList(this.data).then(res=>{
        if(res.data.status=='ok' || res.data.rcode==200){
          this.tableData = res.data.result.data || []
          this.data.total = res.data.result.total || 0
          if(res.data.result.per_page){
            this.data.page_size = res.data.result.per_page
          }
          this.loading = false
        }else{
          this.$message.error(res.data.msg || '获取数据失败')
          this.loading = false
        }
      }).catch(err=>{
        this.$message.error('请求失败')
        this.loading = false
      })
    },
    // 查看详情
    seeInfoFn(row) {
      this.seeinfovisible = true;
      // 直接使用当前行数据作为详情
      this.orderDetail = row
    },
    dialogClose(){
      this.seeinfovisible = false
      this.orderDetail = null
    },
    // 计算可退款数量
    getRefundableCount(row) {
      if (!row) return 0
      const number = parseFloat(row.number) || 0
      const usecount = parseFloat(row.usecount) || 0
      const canclecount = parseFloat(row.canclecount) || 0
      const refundable = number - usecount - canclecount
      return refundable > 0 ? refundable : 0
    },
    // 计算可退款金额
    calculateRefundMoney() {
      if (!this.refundRow || !this.refundData.refundnum) {
        this.refundData.refundmoney = ''
        return
      }
      const refundNum = this.refundData.refundnum
      const price = parseFloat(this.refundRow.price) || 0
      const refundMoney = (refundNum * price).toFixed(2)
      this.refundData.refundmoney = refundMoney
    },
    // 退款
    refundFn(row) {
      this.refundRow = row
      const refundableCount = this.getRefundableCount(row)
      this.refundData.refundnum = refundableCount > 0 ? 1 : 0
      this.calculateRefundMoney()
      this.refundVisible = true
    },
    refundDialogClose(){
      this.refundVisible = false
      this.refundRow = null
      this.refundData.refundnum = 0
      this.refundData.refundmoney = ''
      this.refundLoading = false
    },
    // 确认退款
    confirmRefund() {
      const refundableCount = this.getRefundableCount(this.refundRow)
      if (!this.refundData.refundnum || this.refundData.refundnum <= 0) {
        Message.error('请输入退款数量')
        return
      }
      if (this.refundData.refundnum > refundableCount) {
        Message.error('退款数量不能大于可退款数量')
        return
      }
      if (!this.refundData.refundmoney || this.refundData.refundmoney <= 0) {
        Message.error('退款金额计算错误')
        return
      }
      MessageBox(`此操作将退款, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.refundLoading = true
        let data = {
          token: window.sessionStorage.getItem('Token'),
          jfy_number: this.refundRow.jfy_no,
          refundnum: this.refundData.refundnum.toString(),
          refundmoney: this.refundData.refundmoney.toString(),
          xcx_number: this.refundRow.ordernumber,
          openid: this.refundRow.openid
        }
        xcxRefund(data).then(res => {
          this.refundLoading = false
          if (res.data.status == 'ok' || res.data.rcode == 200) {
            Message.success('退款成功')
            this.refundDialogClose()
            this.getList()
          } else {
            Message.error(res.data.msg || '退款失败')
          }
        }).catch(err => {
          this.refundLoading = false
          Message.error('退款失败')
        })
      }).catch(() => {
        // 取消操作
      })
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 2rem;
}
.conentBox {
  margin-top: 17px;
  .conentTitle {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    .el-input,
    .el-select {
      width: 22rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .el-date-editor {
      width: 28rem;
      margin-bottom: 1rem;
      margin-right: 1rem;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;

  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}

.btns_cao{
  ::v-deep .el-button{
    margin-right: 1rem;
    margin-left: 0;
  }
}

.types_boxs{
  margin-top: 1.2rem;
  display: flex;
  >div{
    padding: 0 1.2rem;
    height: 3.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #E5E5EA;
    cursor: pointer;
    &:nth-child(n+2){
      border-left: 0;
    }
  }
  .type_active{
    color: #246DEB;
    border:1px solid  #246DEB !important;
  }
}

.detail-content {
  .detail-item {
    margin-bottom: 15px;
    .detail-label {
      font-weight: bold;
      margin-right: 10px;
    }
  }
}

.refund-content {
  .refund-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .refund-label {
      font-weight: bold;
      margin-right: 10px;
      width: 120px;
      flex-shrink: 0;
    }
  }
}
</style>

